module.exports = __webpack_public_path__ + "static/media/no_vol_m.93d87bf7.png";